import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, PopoverController, Loading, ToastController, LoadingController, AlertController, Content, MenuController, ModalController } from 'ionic-angular';
import { ProjectTaskModel, ProjectListModel, TeamModel, ProjectCommentModel, ProjectFileModel, ProjectChecklistModel, ProjectCheckItemModel, ProjectUserModel } from '../../model/CronosModel';
import { Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppStore } from '../../store/AppStore';
import { LogoutAction } from '../../store/action/UserActions';
import { SurveyClearErrorsAction } from '../../store/action/SurveyActions';
import { TrainingClearErrorsAction } from '../../store/action/TrainingActions';
import { BrainstormClearErrorsAction } from '../../store/action/BrainstormActions';
import { ClearNotificationsAction } from '../../store/action/NotificationActions';
import { CronosClearErrorsAction, CronosSaveTaskAction, CronosSaveFileAction, CronosReorderAction } from '../../store/action/CronosActions';
import { LoginPage } from '../login/login';
import { CronosFilePage } from '../cronos-file/cronos-file';
import { CronosCategoriesPage } from './../cronos-categories/cronos-categories';
import { CronosMembersPage } from '../cronos-members/cronos-members';
import { CronosPopoverPage } from './../cronos-popover/cronos-popover';
import { CronosService } from './../../services/CronosService';

import _ from 'lodash';

@IonicPage()
@Component({
  selector: 'page-cronos-action',
  templateUrl: 'cronos-action.html'
})
export class CronosActionPage {

  @ViewChild('fileUpload') file;
  @ViewChild('contentMenu') content: Content;

  public projectId: number;
  public projectOwnerId: number;
  public listId: number;
  public listName: string;
  public originalSelectedTask: ProjectTaskModel;
  public selectedTask: ProjectTaskModel;
  public selectedTeam: TeamModel;
  public edit: boolean;
  public lists: Array<ProjectListModel>;
  public comment: string;
  public isLoading: boolean;
  public loader: Loading;
  public defaultSelectOptions = { title: 'Selecione' };
  public maxYear: number;
  public valid: boolean;
  public errorMessage: Array<number> = new Array<number>();

  private userId: number;
  private userName: string;
  private clientId: number;
  private loggingOff: boolean;
  private savingTask: boolean;
  private savingTaskWithMembers: boolean;
  private members: Array<ProjectUserModel>;
  private savingFile: boolean;
  private savingList: boolean;

  private userSubscription: Subscription;
  private cronosSubscription: Subscription;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private store: Store<AppStore>,
    private toastCtrl: ToastController,
    private alertCtrl: AlertController,
    private loadingCtrl: LoadingController,
    private menuCtrl: MenuController,
    private popoverCtrl: PopoverController,
    private modalCtrl: ModalController,
    private cronosService: CronosService) {
  }

  ionViewWillEnter() {
    this.maxYear = new Date().getFullYear() + 50;
    if (this.navParams.get('projectId') != null) {
      this.projectId = this.navParams.get('projectId');
    }
    if (this.navParams.get('ownerId') != null) {
      this.projectOwnerId = this.navParams.get('ownerId');
    }
    if (this.navParams.get('list') != null) {
      this.listId = this.navParams.get('list').id;
      this.listName = this.navParams.get('list').name;
    }
    if (this.navParams.get('task') != null) {
      this.originalSelectedTask = this.navParams.get('task');
      this.selectedTask = {
        boardId: this.originalSelectedTask.boardId,
        clienteId: this.originalSelectedTask.clienteId,
        listId: this.originalSelectedTask.listId,
        closed: this.originalSelectedTask.closed,
        initDate: this.originalSelectedTask.initDate,
        dueDate: this.originalSelectedTask.dueDate,
        hours: this.originalSelectedTask.hours,
        hoursPerformed: this.originalSelectedTask.hoursPerformed,
        conclude: this.originalSelectedTask.conclude,
        concludeDate: this.originalSelectedTask.concludeDate,
        id: this.originalSelectedTask.id,
        name: this.originalSelectedTask.name,
        description: this.originalSelectedTask.description,
        position: this.originalSelectedTask.position,
        status: this.originalSelectedTask.status,
        categories: Object.assign([], this.originalSelectedTask.categories),
        checkLists: Object.assign([], this.originalSelectedTask.checkLists),
        checkListsTotalItems: this.originalSelectedTask.checkListsTotalItems,
        checkListsTotalCompleted: this.originalSelectedTask.checkListsTotalCompleted,
        comments: Object.assign([], this.originalSelectedTask.comments),
        files: Object.assign([], this.originalSelectedTask.files),
        users: Object.assign([], this.originalSelectedTask.users),
        currentListId: this.listId
      };
    }
    if (this.navParams.get('team') != null) {
      this.selectedTeam = this.navParams.get('team');
    }
    if (this.navParams.get('edit') != null) {
      this.edit = this.navParams.get('edit');
    }
    if (this.navParams.get('lists')) {
      this.lists = this.navParams.get('lists');
    }
    this.loggingOff = false;

    this.isLoading = false;
    this.userSubscription = this.store.select('userState').subscribe(userState => {
      if (userState.expired == true && !this.loggingOff) {
        this.loggingOff = true;
        this.logoff();
      }
      if (userState.user != null) {
        this.userId = userState.user.id;
        this.clientId = userState.user.clienteId;
        this.userName = userState.user.nome;
        if (this.edit == false) {
          this.selectedTask.clienteId = this.clientId;
        }
      }
    });

    this.savingTask = false;
    this.savingTaskWithMembers = false;
    this.members = [];
    this.savingFile = false;
    this.savingList = false;
    this.cronosSubscription = this.store.select('cronosState').subscribe(cronosState => {
      if ((cronosState.savingTask || cronosState.savingComment || cronosState.savingFile) && !this.isLoading) {
        if (this.loader == null) {
          this.loader = this.loadingCtrl.create({
            content: "Aguarde..."
          });
          this.loader.present();
        }
        this.isLoading = true;
      }
      if (!cronosState.savingTask && !cronosState.savingComment && !cronosState.savingFile && this.isLoading && !this.savingFile) {
        this.isLoading = false;
        this.loader.dismiss();
        this.loader = null;
      }
      if (cronosState.errorTask) {
        setTimeout(() => {
          if (!this.loggingOff) {
            this.presentToast('Erro ao atualizar as informações');
          }
        }, 200);
      }
      if (cronosState.errorComment) {
        setTimeout(() => {
          if (!this.loggingOff) {
            this.presentToast('Erro ao gravar o comentário');
          }
        }, 200);
      }
      if (cronosState.errorFile) {
        setTimeout(() => {
          if (!this.loggingOff) {
            this.presentToast('Erro ao gravar o arquivo');
          }
        }, 200);
      }
      if (cronosState.errorReorder) {
        setTimeout(() => {
          if (!this.loggingOff) {
            this.presentToast('Erro ao gravar a Ação');
          }
        }, 200);
      }
      if (this.savingFile && cronosState.fileData != null) {
        this.savingFile = false;
        this.selectedTask.files.push(cronosState.fileData);
        this.saveTask();
        return;
      }
      if (this.savingTask && !cronosState.savingTask) {
        this.savingTask = false;
        this.selectedTask = _.assign(this.selectedTask, cronosState.savedTaskData, {
          categories: (this.selectedTask.categories || []),
          users: (this.selectedTask.users || []),
          checkLists: (this.selectedTask.checkLists || []),
          comments: (this.selectedTask.comments || [])
        });

        if (this.edit == true) {
          this.presentToast('Ação alterada com sucesso!');
          this.cronosService.loadUserInitials(this.selectedTask, this.selectedTeam);
          this.cronosService.completeComments(this.selectedTask, this.selectedTeam);
          this.cronosService.completeChecklists(this.selectedTask);
        } else {
          if (this.savingTaskWithMembers) {
            this.savingTask = true;
            this.selectedTask.users = this.members;
            this.store.dispatch(new CronosSaveTaskAction({ projectId: this.projectId, listId: this.listId, model: this.selectedTask }));
            this.savingTaskWithMembers = false;
            this.members = [];
          } else {
            this.lists = cronosState.projects.find(x => x.id == this.projectId).lists;
            let selectedList = this.lists.find(x => x.id == this.listId);
            if (selectedList != null) {
              this.savingList = true;
              this.store.dispatch(new CronosReorderAction({ projectId: this.projectId, model: selectedList }));
            }
          }
        }
      }
      if (this.savingList && !cronosState.savingReoder) {
        this.presentToast('Ação adicionada com sucesso!');
        this.navCtrl.pop();
      }
    });

    this.menuCtrl.enable(true, 'menu2');
    this.menuCtrl.enable(false, 'menuPrincipal');
  }

  ionViewWillLeave() {
    this.menuCtrl.enable(false, 'menu2');
    this.menuCtrl.enable(true, 'menuPrincipal');
    if (this.userSubscription != null) this.userSubscription.unsubscribe();
    if (this.cronosSubscription != null) this.cronosSubscription.unsubscribe();
  }

  logoff() {
    this.presentToast('Acesso expirado. Efetue login novamente. (2)');
    localStorage.removeItem('expirationDate');
    this.store.dispatch(new LogoutAction());
    this.store.dispatch(new SurveyClearErrorsAction());
    this.store.dispatch(new TrainingClearErrorsAction());
    this.store.dispatch(new BrainstormClearErrorsAction());
    this.store.dispatch(new ClearNotificationsAction());
    this.store.dispatch(new CronosClearErrorsAction());
    this.navCtrl.setRoot(LoginPage);
  }

  presentToast(message: string) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 2000,
      position: 'bottom'
    });
    toast.present();
  }

  toggleSection(i) {
    this.selectedTask.checkLists[i].isOpen = !this.selectedTask.checkLists[i].isOpen;
  }

  presentPopover(ev) {
    let popover = this.popoverCtrl.create(CronosPopoverPage, {
      page: this,
      users: this.selectedTeam.usuarios
    });
    popover.present({
      ev: ev
    });
  }

  concludeTask() {
    this.selectedTask.status = 2;
    this.selectedTask.conclude = true;
    this.selectedTask.concludeDate = new Date();
  }

  reactivateTask() {
    if (this.selectedTask.dueDate == null) {
      this.selectedTask.status = 0;
    } else if (new Date(this.selectedTask.dueDate) < new Date()) {
      this.selectedTask.status = 3;
    } else {
      this.selectedTask.status = 1;
    }
    this.selectedTask.conclude = false;
    this.selectedTask.concludeDate = null;
  }

  toggleCheckItem(checklist: ProjectChecklistModel) {
    this.selectedTask.checkListsTotalCompleted = checklist.checkItems.filter(x => x.conclude == true).length;
    checklist.percentage = (checklist.checkItems.filter(x => x.conclude == true).length / checklist.checkItems.length) * 100;
    this.saveCheckList(checklist, false);
  }

  saveTask() {
    this.valid = true;
    this.errorMessage = new Array<number>();
    if (this.listId == null || this.listId == 0) {
      this.valid = false;
      this.errorMessage.push(1);
    }
    if (this.selectedTask.name == null || this.selectedTask.name == '') {
      this.valid = false;
      this.errorMessage.push(2);
    }
    if (this.valid) {
      if (this.selectedTask.conclude == null || this.selectedTask.conclude == false) {
        if (this.selectedTask.dueDate == null || this.selectedTask.dueDate == '') {
          this.selectedTask.status = 0;
        } else {
          const dueDate = new Date(this.selectedTask.dueDate);
          const currentDate = new Date();
          if (dueDate > currentDate) {
            this.selectedTask.status = 1;
          } else {
            this.selectedTask.status = 3;
          }
        }
      }
      this.savingTask = true;
      if (this.edit == false) {
        if (this.selectedTask.users != null && this.selectedTask.users.length > 0) {
          this.members = this.selectedTask.users;
          this.savingTaskWithMembers = true;
          this.selectedTask.users = [];
        }
        let selectedList = this.lists.find(x => x.id == this.listId);
        if (selectedList != null && selectedList.tasks != null && selectedList.tasks.length > 0) {
          this.selectedTask.position = Math.max.apply(Math, this.lists.find(x => x.id == this.listId).tasks.map((x) => x.position)) + 1;
        } else {
          this.selectedTask.position = 0;
        }
      }
      this.store.dispatch(new CronosSaveTaskAction({ projectId: this.projectId, listId: this.listId, model: this.selectedTask }));
    }
  }

  addComment() {
    let commentModel: ProjectCommentModel = {
      clientId: this.clientId,
      taskId: this.selectedTask.id,
      id: null,
      name: this.comment,
      registerDate: new Date(),
      editionDate: null,
      sendDate: new Date(),
      senderUserId: this.userId,
      senderUserName: this.userName,
      targetUsers: this.getTargetUsers(this.comment)
    };
    this.saveComment(commentModel, true);
  }

  saveComment(commentModel, isNewComment) {
    this.cronosService.saveComment(commentModel).subscribe(item => {
      if (isNewComment)
        this.selectedTask.comments.unshift(_.assign({}, commentModel, item));

      this.comment = '';
      this.presentToast("Salvo com sucesso");
    })
  }

  getTargetUsers(commentName) {
    if (commentName) {
      var targetUsers = commentName.match(/\([\w.]+@\w+\.\w+(\.\w{2})?\)/gi);
      return targetUsers ? "{" + Array.from(new Set(targetUsers)).join().replace(/[\(\)]/g, "") + "}" : null;
    } else {
      return null;
    }
  }

  addFile() {
    this.file.nativeElement.click();
    this.menuCtrl.close();
  }

  onFilesAdded() {
    let fileToUpload: File = null;
    const files: { [key: string]: File } = this.file.nativeElement.files;
    for (let key in files) {
      if (!isNaN(parseInt(key))) {
        fileToUpload = files[key];
        break;
      }
    }
    if (fileToUpload != null) {
      const fileSizeMb = fileToUpload.size / 1024 / 1024;
      if (fileSizeMb > 10) {
        const prompt = this.alertCtrl.create({
          title: 'Tamanho Excedido',
          message: 'O tamanho máximo de arquivo é de 10MB.',
          buttons: ['Ok']
        });
        prompt.present();
        return;
      }
    }
    let fileModel: ProjectFileModel = {
      clientId: this.clientId,
      id: null,
      name: fileToUpload.name,
      registerDate: new Date(),
      size: fileToUpload.size,
      taskId: this.selectedTask.id,
      type: fileToUpload.type,
      url: null,
      fileKey: null,
      newFileKey: null
    };
    this.savingFile = true;
    this.store.dispatch(new CronosSaveFileAction({ projectId: this.projectId, listId: this.listId, taskId: this.selectedTask.id, model: fileModel, file: fileToUpload }));
  }

  openFile(filename: string, type: string, url: string) {
    this.navCtrl.push(CronosFilePage, { filename, type, url });
  }

  getFileExtension(filename: string): string {
    var extension = filename.replace(/^.*\./, '');
    if (extension == filename) {
      return '???';
    } else {
      return extension.toUpperCase();
    }
  }

  cancel() {
    this.navCtrl.pop();
  }

  openMenu() {
    if (!this.menuCtrl.isOpen()) {
      this.menuCtrl.open();
    } else {
      this.menuCtrl.close();
    }
  }

  openAddMembers() {
    const modal = this.modalCtrl.create(CronosMembersPage, { members: this.selectedTask.users, users: this.selectedTeam.usuarios, taskId: this.selectedTask.id, teamId: this.selectedTeam.id, clientId: this.clientId }, { showBackdrop: true, enableBackdropDismiss: false  });
    modal.onDidDismiss(members => {
      this.selectedTask.users = (members || this.selectedTask.users);
    });
    modal.present();
    this.menuCtrl.close();
  }

  openAddChecklist() {
    const prompt = this.alertCtrl.create({
      title: 'Nova Lista de Tarefa',
      message: "Digite o Título da Nova Lista de Tarefa",
      inputs: [
        {
          name: 'titulo',
          placeholder: 'Título'
        },
      ],
      buttons: [
        {
          text: 'Cancelar'
        },
        {
          text: 'Adicionar',
          handler: data => {
            if (data != null && data.titulo != null && data.titulo != '') {
              this.saveCheckList(this.newCheckList(data.titulo), true);
            } else {
              this.presentToast('Digite um Título para a Nova Lista de Tarefa');
              return false;
            }
          }
        }
      ]
    });
    prompt.present();
    this.menuCtrl.close();
  }

  saveCheckList(checkList, isNewCheckList) {
    this.cronosService.saveCheckList(checkList)
      .subscribe(data => {
        if (isNewCheckList)
          this.selectedTask.checkLists.push(_.assign({}, checkList, data));

        this.presentToast("Salvo com sucesso");
      });
  }

  newCheckList(title) {
    return {
      taskId: this.selectedTask.id,
      clientId: this.clientId,
      id: null,
      name: title,
      position: this.selectedTask.checkLists.length,
      percentage: 0,
      isOpen: true,
      checkItems: []
    }
  }

  removeCheckList(checklist) {
    this.cronosService.removeCheckList(checklist.id)
      .subscribe(() => {
        _.remove(this.selectedTask.checkLists, checklist);
        _.forEach(this.selectedTask.checkLists, (item, index) => {
          this.setPositionCheckList(item, index);
        });
        this.presentToast("Removido com sucesso");
      });
  }

  setPositionCheckList(checkList, index) {
    checkList.position = index;
  }

  addCheckItem(checklist: ProjectChecklistModel) {
    const prompt = this.alertCtrl.create({
      title: 'Novo Item',
      message: "Digite o Novo Item para a Lista de Tarefa",
      inputs: [
        {
          name: 'descricao',
          placeholder: 'Descrição'
        },
      ],
      buttons: [
        {
          text: 'Cancelar'
        },
        {
          text: 'Adicionar',
          handler: data => {
            if (data != null && data.descricao != null && data.descricao != '') {
              checklist.checkItems.push({
                clientId: this.clientId,
                conclude: false,
                name: data.descricao,
                position: checklist.checkItems.length
              });
              this.saveCheckList(checklist, false);
            } else {
              this.presentToast('Digite a Descrição do Novo Item');
              return false;
            }
          }
        }
      ]
    });
    prompt.present();
  }

  editCheckItem(checklist: ProjectChecklistModel, checkItem: ProjectCheckItemModel) {
    const prompt = this.alertCtrl.create({
      title: 'Editar Item',
      message: "Digite a nova Descrição do Item",
      inputs: [
        {
          name: 'descricao',
          placeholder: 'Descrição',
          value: checkItem.name
        },
      ],
      buttons: [
        {
          text: 'Cancelar'
        },
        {
          text: 'Salvar',
          handler: data => {
            if (data != null && data.descricao != null && data.descricao != '') {
              checkItem.name = data.descricao;
              this.saveCheckList(checklist, false);
            } else {
              this.presentToast('Digite a Descrição do Item');
              return false;
            }
          }
        }
      ]
    });
    prompt.present();
  }

  removeCheckItem(checkList: ProjectChecklistModel, checkItem: ProjectCheckItemModel) {
    _.remove(checkList.checkItems, checkItem);
    checkList.checkItems.forEach(this.setPosition);
    this.saveCheckList(checkList, false);
  }

  setPosition(checkItem, index) {
    checkItem.position = index;
  }

  editComment(comment: ProjectCommentModel) {
    const prompt = this.alertCtrl.create({
      title: 'Editar Comentário',
      message: "Digite o novo Comentário",
      inputs: [
        {
          name: 'descricao',
          placeholder: 'Descrição',
          value: comment.name
        },
      ],
      buttons: [
        {
          text: 'Cancelar'
        },
        {
          text: 'Salvar',
          handler: data => {
            if (data != null && data.descricao != null && data.descricao != '') {
              comment.name = data.descricao;
              comment.sendDate = new Date();
              this.saveComment(comment, false);
            } else {
              this.presentToast('Digite a Descrição do Comentário');
              return false;
            }
          }
        }
      ]
    });
    prompt.present();
  }

  removeComment(comment) {
    this.cronosService.removeComment(comment.id).subscribe(() => {
      _.remove(this.selectedTask.comments, comment);
      this.presentToast("Removido com sucesso");
    })
  }

  removeFile(file: ProjectFileModel) {
    const confirm = this.alertCtrl.create({
      title: 'Confirma Exclusão',
      buttons: [
        {
          text: 'Cancelar'
        },
        {
          text: 'Confirmar',
          handler: () => {
            this.cronosService.removeFile(file).subscribe(x => {
              this.presentToast('Arquivo removido com sucesso');
              const idx = this.originalSelectedTask.files.findIndex(x => x.id == file.id);
              this.originalSelectedTask.files.splice(idx, 1);
              this.selectedTask.files.splice(idx, 1);
            },
              err => {
                this.presentToast('Houve um erro ao remover o arquivo');
              });
          }
        }
      ]
    });
    confirm.present();
  }

  openAddCategory() {
    const modal = this.modalCtrl.create(CronosCategoriesPage, { categories: this.selectedTask.categories, boardId: this.selectedTask.boardId, clientId: this.clientId }, { showBackdrop: true });
    modal.onDidDismiss(categories => {
      this.selectedTask.categories = categories;
    });
    modal.present();
    this.menuCtrl.close();
  }

  isOwner(): boolean {
    if (this.selectedTeam) {
      if (this.selectedTeam.id == 0) {
        return this.projectOwnerId == this.userId;
      } else {
        return true;
      }
    } else {
      return false;
    }
  }

  isCommentOwner(comment: ProjectCommentModel) {
    return comment.senderUserId == this.userId;
  }

}



// WEBPACK FOOTER //
// ./src/pages/cronos-action/cronos-action.ts